module.exports = __webpack_public_path__ + "media/images/unemployment_by_county_dec_2020-1016c923fece11811dd852aa913d029a.png";